<ics-app-content>
  <div class="dashboard">
    @if (isAuthenticated()) {
      <section class="dashboard__navigation" data-cy="dashboard-navigation">
        @for (parentRoute of routes; track parentRoute) {
          <app-navigation-card
            *needsAuthorization="parentRoute.authorizations || []"
            [route]="parentRoute" />
        }
      </section>
    } @else {
      <div class="dashboard__welcome">
        <h2>Willkommen</h2>
        <a mat-raised-button color="primary" [routerLink]="['login']">
          Weiter zur Anmeldung
        </a>
      </div>
    }
  </div>
</ics-app-content>
